export default async function operator({ next }) {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    
    if (!user) {
      return next({ name: "Login" });
    }

    // Verificar que el usuario sea operador (role '3') o asesor (role '6',
    // mismas funciones que el operario)
    if (!['3', '6'].includes(String(user.role))) {
      // Si no es operador, redirigir al dashboard principal
      return next({ name: "Dashboard" });
    }

    next();
  } catch (error) {
    console.error("Error en middleware operator:", error);
    return next({ name: "Login" });
  }
}
